import { Container, Paper } from '@mantine/core'

import type { JSX } from 'react'

export function Placeholder(): JSX.Element {
  return (
    <Container>
      <Paper radius="sm" shadow="sm" p="xl" m="xl">
        Under construction 🚧
      </Paper>
    </Container>
  )
}
